import $ from 'jquery';

$.fn.xiTabularSelect = function (options) {
  return this.each((_i, el) => setupTabularSelect.apply(el, options));
};

function setupTabularSelect(options) {
  const o = $.extend({}, $.fn.xiTabularSelect.defaults, options);

  if (o.headers == null) {
    o.headers = ($(this).data('xi-headers') || '')
      .toString()
      .split(',')
      .map((s) => s.trim());
  }

  o.colWidths = ($(this).data('xi-col-widths') || '')
    .toString()
    .split(',')
    .map((s) => s.trim());

  const name = $(this).attr('name');

  const optionEls = $(this).find('option');
  const value = optionEls.filter(':selected').attr('value');
  o.value = value;

  const opts = optionEls
    .map((_i, opt) => ({
      value: opt.value,
      label: opt.innerHTML
        .trim()
        .split(o.separator)
        .map((s) => s.trim()),
    }))
    .get();

  o.els = {
    trigger: $(`
      <button type="button" class="form-control xi-tabular-select-trigger">
      </button>
    `).on('click', () => $(this).xiTabularSelectChoose(o, opts)),

    hidden: $(`
      <input
        type="hidden"
        name="${escape(name)}"
        value="${escape(value)}"
      />
    `),
  };

  $(this).xiTabularSelectOnSelect(value, o, opts);

  $(this).replaceWith(o.els.trigger);
  o.els.hidden.insertAfter(o.els.trigger);
}

$.fn.xiTabularSelectChoose = function (o, opts) {
  const self = $(this);

  $.dim();

  o.els.modal = $(`
    <div class="xi-tabular-select-modal">
      <button type="button" class="close-button">schließen</button>
      ${generateTable(o, opts)}
    </div>
  `)
    .appendTo(document.body)
    .hide()
    .fadeIn()
    .on('click', 'tbody td', function () {
      const id = parseInt($(this).closest('tr').data('id'), 10);
      self.xiTabularSelectOnSelect(id, o, opts);
      self.xiTabularSelectCancel(o);

      $(this)
        .closest('.xi-tabular-select-modal')
        .fadeOut(function () {
          $(this).remove();
        });

      $.undim();
    });

  $('#dimmer, .xi-tabular-select-modal .close-button').on('click', () => {
    self.xiTabularSelectCancel(o);
  });
};

$.fn.xiTabularSelectOnSelect = function (id, o, opts) {
  const selectedOpt = opts.find((opt) => opt.value == id);

  let selectedLabel = 'Keine Auswahl';
  if (selectedOpt && selectedOpt.label[1] > 0) {
    selectedLabel = `
      <strong>${escape(selectedOpt.label[0])}</strong>
      <code>${escape(selectedOpt.label[1])}</code>
      -
      "${escape(selectedOpt.label[2])}"
    `;
  }
  o.els.trigger.html(selectedLabel);
  o.els.hidden.val(id);
  o.value = id;
};

$.fn.xiTabularSelectCancel = function (o) {
  o.els.modal.fadeOut(function () {
    $(this).remove();
  });

  $.undim();
};

function generateTable(o, opts) {
  const head = generateHead(o);
  const body = generateBody(o, opts);
  return `<table>${head}${body}</table>`;
}

function generateHead(o) {
  const ths = o.headers.map((h, i) => {
    let s = '';
    if (o.colWidths && o.colWidths[i]) {
      s = ` style="width: ${o.colWidths[i]}"`;
    }
    return `<th${s}>${h}</th>`;
  });
  return `<thead><tr>${ths.join('')}</tr></thead>`;
}

function generateBody(o, opts) {
  const rows = opts.map((opt) => {
    const cells = opt.label.map((l, i) => {
      let s = '';
      if (o.colWidths && o.colWidths[i]) {
        s = ` style="width: ${o.colWidths[i]}"`;
      }
      return `<td${s}>${l}</td>`;
    });

    let cls = '';
    if (opt.value == o.value) {
      cls = 'class="selected"';
    }

    return `<tr ${cls} data-id="${opt.value}">${cells.join('')}<tr>`;
  });

  return `<tbody>${rows.join('')}</tbody>`;
}

function escape(text) {
  return $('<div/>').text(text).html();
}

$.fn.xiTabularSelect.defaults = {
  separator: '|',
  headers: undefined,
  colWidths: undefined,
};
